document.addEventListener("DOMContentLoaded", function () {
  // Parse menu data from the script tag
  const menuDataScript = document.getElementById("mobile-menu-data");
  if (!menuDataScript) return;
  const menuData = JSON.parse(menuDataScript.textContent);

  // Get all main menu buttons and the sub-panel container
  const mainLinks = document.querySelectorAll(".mobile-nav__main-link");
  const mainItems = document.querySelectorAll(".mobile-nav__main-item");
  const subPanel = document.getElementById("mobile-nav-sub-panelMobileNav");
  const indicator = document.querySelector(".active-indicator");
  if (!mainLinks.length || !subPanel || !mainItems.length || !indicator) return;

  let lastClick = 0;
  let currentIdx = -1;

  function renderSubPanel(idx) {
    if (currentIdx === idx) return; // Only update if index changes
    currentIdx = idx;
    const mainItem = menuData[idx];
    let html = "";

    if (mainItem && Array.isArray(mainItem.links) && mainItem.links.length > 0) {
      html += `<div class="mobile-nav__submenu-title-wrap">
        <a href="${mainItem.url}" class="mobile-nav__submenu-main-title">${mainItem.title}</a>
      </div>`;
      html += '<div class="mobile-nav__submenu-grid">';
      mainItem.links.forEach(link => {
        html += `
          <div class="mobile-nav__submenu-item">
            <a href="${link.url}">
              ${link.image ? `<div class="mobile-nav__submenu-img-wrap"><img src="${link.image}" alt="${link.title}" class="mobile-nav__submenu-img fade-image"></div>` : ""}
              <span class="mobile-nav__submenu-title">${link.title}</span>
            </a>
          </div>
        `;
      });
      html += "</div>";
    } else {
      html = '<div class="mobile-nav__submenu-empty">No subcategories</div>';
    }
    subPanel.innerHTML = html;
  
    const imgs = subPanel.querySelectorAll(".fade-image");
    imgs.forEach(img => {
      img.style.opacity = "0";
      img.addEventListener("load", () => {
        img.style.transition = "opacity 0.4s ease-in-out";
        img.style.opacity = "1";
      });

      // For cached images
      if (img.complete) {
        img.style.transition = "opacity 0.4s ease-in-out";
        img.style.opacity = "1";
      }
    });

  }

  function moveIndicator(idx) {
    const item = mainItems[idx];
    if (!item || !indicator) return;
    const top = item.offsetTop;
    indicator.style.top = top + "px";
    indicator.style.height = item.offsetHeight + "px";
  }

  mainLinks.forEach((btn, idx) => {
    btn.setAttribute("role", "tab");
    btn.setAttribute("aria-selected", idx === 0 ? "true" : "false");
    btn.addEventListener("click", function () {
      const now = Date.now();
      if (now - lastClick < 300) return; // Debounce rapid clicks
      lastClick = now;
      if (btn.classList.contains("active")) return; // Skip if already active

      mainLinks.forEach((b, i) => {
        b.classList.remove("active");
        b.setAttribute("aria-selected", "false");
      });
      mainItems.forEach(item => item.classList.remove("active"));
      btn.classList.add("active");
      btn.setAttribute("aria-selected", "true");
      if (mainItems[idx]) mainItems[idx].classList.add("active");

      moveIndicator(idx);

      const mainItem = menuData[idx];
      if (!mainItem.links || mainItem.links.length === 0) {
        window.location.href = mainItem.url;
        return;
      }
      renderSubPanel(idx);
    });
  });

  // Render the first submenu and set active class by default
  renderSubPanel(0);
  if (mainLinks.length > 0) {
    mainLinks[0].classList.add("active");
    mainLinks[0].setAttribute("aria-selected", "true");
  }
  if (mainItems.length > 0) mainItems[0].classList.add("active");
  moveIndicator(0);
});

document.addEventListener('click', function(event) {
  if (!document.body.classList.contains('reveal-mobile-nav')) return;
  const showSearchBtn = event.target.closest('.show-search-link');
  if (showSearchBtn) {
    if (showSearchBtn.tagName === 'A') event.preventDefault();
    document.body.classList.remove(
      'reveal-mobile-nav',
      'enable-mobile-nav-transition',
      'reveal-mobile-nav--revealed'
    );
    document.body.classList.add('show-search');
  }
});